import React from "react";

const PdfViewer = ({ src, url }) => {
  return (
    <iframe
      src={url || `data:application/pdf;base64,${src}`}
      style={{ width: "100%", height: "80vh" }}
      title="pdf viewer"
    />
  );
};

export default PdfViewer;
